import React from 'react';
import _ from 'lodash';
import { useParams } from "react-router-dom";
import './T003.scss';

import * as DataAPI from "./Common/DataAPI";
import constants from "./Common/constants";

class T003 extends React.Component {
  constructor(props) {
    super();

    this.state = {
      deviceId: _.get(props.params, 'deviceId'),
      queueId: _.get(props.params, 'queueId'),
      myTicket: _.get(props.params, 'myTicket'),
      queue: null,
      device: null,
    };
  }

  UNSAFE_componentWillMount() {
    this.getDevice();
    this.getQueue();
  }

  getDevice() {
    DataAPI.get(`${constants.queueStatusDomain}/api/public/device/${this.state.deviceId}`, {}, (err, device) => {
      if (err) return console.error('device error:', err);

      this.setState({
        device,
      });
    });
  }

  getQueue() {
    DataAPI.get(`${constants.queueStatusDomain}/api/public/queue/${this.state.queueId}`, {}, (err, queue) => {
      if (err) return console.error('queue error:', err);

      _.set(queue, 'lastNumberToShow', _.padStart(queue.lastNumber, queue.numberOfDigit, '0'));

      this.setState({
        queue,
      });
    });
  }

  render() {
    return (
      <div className="t003-block">
        <div className="logo-block">
          <img alt="logo" src={_.get(this.state.device, 'logo.url')} />
        </div>
        <img alt="ticket" className="ticket-img" src={'/ticket-003.png'} />
        <div className="ticket-info">
          <div className="current-number-title">現時叫號</div>
          <div className="current-number">
            {_.get(this.state.queue, 'prefix', '') + _.get(this.state.queue, 'lastNumberToShow', '')}
          </div>
          <div className="line" />
          <div className="your-number-title">你的輪候號碼</div>
          <div className="your-number">{this.state.myTicket}</div>
        </div>

        <div className="footer-block">
          <div className="outer-block">
            <div className="provided-by">Provided by</div>
            <img alt="LDS logo" src={'/logo-ld-yellow.png'} />
          </div>
        </div>
      </div>
    )
  }
}

const T003Params = (props) => (
  <T003
    {...props}
    params={useParams()}
  />
)

export default T003Params;
